import {isNil} from 'ramda';

import {usePricedItemGroup} from './usePricedItemGroup';

/**
 * The trims that the open group of the model year creates, in the order they were added. None when
 * no group is open. The Variant matrix shows them as rows and the trim pickers offer them, so a
 * grouped write can name them (F1 addendum 4.4).
 */
export function useGroupedNewTrims(modelYearId?: string) {
  const group = usePricedItemGroup(modelYearId);
  return (group?.entries ?? []).flatMap(({createdTrim}) =>
    isNil(createdTrim) ? [] : [createdTrim]
  );
}
